import { render, staticRenderFns } from "./WithdrawDepotView.vue?vue&type=template&id=0afb9c20&scoped=true"
import script from "./WithdrawDepotView.vue?vue&type=script&lang=ts"
export * from "./WithdrawDepotView.vue?vue&type=script&lang=ts"
import style0 from "./WithdrawDepotView.vue?vue&type=style&index=0&id=0afb9c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb9c20",
  null
  
)

export default component.exports